import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-spinner-overlay',
    templateUrl: './spinner-overlay.component.html',
    standalone: false
})
export class SpinnerOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
